export const CONFIRM_DIALOG = {
  info: "<i class='bx bx-info-circle text-3xl '></i>",
  warning: `<i class="bx bx-error text-5xl "></i>`,
} as const;
